@use "~theme/typography";

.container {
  display: flex;
}

// Icon SVGs are all slightly different dimensions, which makes alignment hard.
// Normalize by centering them all within a fixed 28px x 28px wrapper.
.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  margin-right: 12px;
}

.itemWrapper {
  margin-top: 3px; // For visually pleasing alignment with icon
}

.item {
  @include typography.body;
  color: var(--black);
}

.caveat {
  @include typography.caption;
  color: var(--black-at-75);
}
